export default __webpack_public_path__ + "files/mnj_presentation_ru.pdf";